import { put, takeLatest } from 'redux-saga/effects';

import { Types, Creators as CreditCardCreators } from '../../reducers/creditCard';

function* clearCreditCards({ totalValueOrder }) {
  yield put(CreditCardCreators.addCreditCardRequest(totalValueOrder));
}

export default function* watch() {
  yield takeLatest(Types.CLEAR_CREDIT_CARDS_REQUEST, clearCreditCards);
}
